/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import { Container } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const styles = (theme) => {
    const colors = {
        white: '#ffff',
    };

    const minWidth = {
        small_screen_down: '768',
        small_medium_down: '991',
    };

    const maxWidth = {
        medium_screen_down: '1024',
    };

    const typography = {
        font_size_lg_track_order_title: '2.5rem',
        font_weight_bolder: 'bolder',
        font_weight_normal: 'normal',
        font_family_sans_serif: 'Hind, sans-serif',
        font_family_bebas: 'BebasNeue',
    };

    return ({
        container: {
            '@media (min-width: 1265px)': {
                maxWidth: '1270px',
            },
            '& #aboutUsCMSPage': {
                '& .desktop-about-us': {
                    '& .about-us-img-div': {
                        position: 'relative',
                        textAlign: 'center',
                        '& #florists-img': {
                            width: '100%',
                            position: 'relative',
                        },
                        '& .banner-div': {
                            background: 'rgba(0, 0, 0, 0.5)',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        },
                        '& .banner-text': {
                            padding: '10px 150px',
                            marginTop: '48px',
                            marginBottom: '48px',
                            color: colors.white,
                            textTransform: 'uppercase',
                            fontSize: typography.font_size_lg_track_order_title,
                            fontWeight: typography.font_weight_bolder,
                            whiteSpace: 'nowrap',
                            fontFamily: typography.font_family_bebas,
                        },
                    },
                    [theme.breakpoints.up(minWidth.small_medium_down)]: {
                        '& .about-us-page-content': {
                            width: '60%',
                            margin: '0 auto',
                            '& img': {
                                width: '100%',
                                zIndex: 9,
                                position: 'relative',
                            },
                        },
                    },
                },
                '& .mobile-about-us': {
                    '& .about-us-img-div': {
                        position: 'relative',
                        textAlign: 'center',
                        '& #florists-img-mobile': {
                            width: '100%',
                            position: 'relative',
                        },
                        '& #florists-img-mobile-bottom': {
                            zIndex: '9',
                            position: 'relative',
                        },
                        '& .banner-div': {
                            background: 'rgba(0, 0, 0, 0.5)',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        },
                        '& .banner-text': {
                            margin: '40px 30px',
                            color: colors.white,
                            textTransform: 'uppercase',
                            fontSize: typography.font_size_lg_track_order_title,
                            fontFamily: 'BebasNeue',
                            fontWeight: typography.font_weight_bolder,
                            whiteSpace: 'nowrap',
                        },
                    },
                    [theme.breakpoints.between(minWidth.small_screen_down, maxWidth.medium_screen_down)]: {
                        '& .about-us-img-div': {
                            width: '50%',
                            margin: 'auto',
                            display: 'block',
                        },
                    },
                    '& img': {
                        maxWidth: '100%',
                    },
                },
                [theme.breakpoints.up(799)]: {
                    '& .desktop-about-us': {
                        display: 'block',
                    },
                    '& .mobile-about-us': {
                        display: 'none',
                    },
                },
                [theme.breakpoints.down(800)]: {
                    '& .desktop-about-us': {
                        display: 'none',
                    },
                    '& .mobile-about-us': {
                        display: 'block',
                    },
                },
            },
            '& .about-us-page-content': {
                position: 'relative',
                minHeigth: '1px',
                padding: '50px 10px',
                [theme.breakpoints.down(minWidth.small_medium_down)]: {
                    width: '100%',
                },
                '&. about-us-img-div': {
                    textAlign: 'left',
                },
                '& .about-us-heading': {
                    textAlign: 'center',
                    lineHeight: '1.75rem',
                    fontSize: '1.75rem',
                    fontFamily: 'BebasNeue',
                    marginTop: '1rem',
                    marginBottom: '2rem',
                },
                '& .about-us-info-line': {
                    textAlign: 'center',
                    fontSize: '1rem',
                    fontWeight: typography.font_weight_normal,
                    lineHeight: '1.56rem',
                    fontFamily: typography.font_family_sans_serif,
                    color: '#212121',
                    [theme.breakpoints.down(minWidth.small_screen_down)]: {
                        textAlign: 'center',
                        fontSize: '1rem',
                        fontWeight: typography.font_weight_normal,
                        fontFamily: typography.font_family_sans_serif,
                        lineHeight: 1.5,
                        color: '#212121',
                    },
                },
                '& #florists-img': {
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: '100%',
                },
            },
            '& .container ': {
                '& .container': {
                    maxWidth: '100% !important',
                    padding: '0 !important',
                },
            },
        },
    });
};

const PlantsAboutUs = ({ classes, data }) => {
    const {
        article_header = '', article_body = '', hero: { hero_image_desktop, hero_image_mobile, title } = {}, seo = {},
    } = data;
    const bannerImg = hero_image_desktop?.url || null;
    const mobileBanner = hero_image_mobile?.url || null;
    return (
        <>
            {
                seo?.seo_searchable
                    ? (
                        <GraphqlSeoHeadTags seoData={seo} alternativeLang="true" />
                    ) : null
            }
            <div>
                <Container className={classes.container}>
                    <div id="aboutUsCMSPage">
                        <div className="desktop-about-us">
                            <div className="about-us-img-div">
                                <img id="florists-img" src={bannerImg} alt="" />
                                <div className="banner-div">
                                    <p role="heading" aria-label="title text" aria-level="3" className="banner-text">{title}</p>
                                </div>
                            </div>
                            <div className="about-us-page-content">
                                <p className="about-us-heading" role="heading" aria-label="our story heading" aria-level="1"><strong>{article_header}</strong></p>
                                <ReactMarkdown escapeHtml={false} source={article_body} className="about-us-info-line" />
                            </div>
                        </div>
                        <div className="mobile-about-us">
                            <div className="about-us-img-div">
                                <img id="florists-img-mobile" src={mobileBanner} alt="" />
                                <div className="banner-div">
                                    <p role="region" aria-label="title text mobile" className="banner-text">{title}</p>
                                </div>
                            </div>
                            <div className="about-us-page-content">
                                <p className="about-us-heading"><strong>{article_header}</strong></p>
                                <div className="about-us-info-line">
                                    <ReactMarkdown escapeHtml={false} source={article_body} className="about-us-info-line" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

PlantsAboutUs.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(PlantsAboutUs);
